import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-36182e41"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collapse-title" }
const _hoisted_2 = { class: "collapse-title" }
const _hoisted_3 = { class: "collapse-title" }
const _hoisted_4 = { class: "collapse-title" }
const _hoisted_5 = { class: "collapse-title" }
const _hoisted_6 = {
  key: 0,
  class: "action-bar"
}

import { computed, onMounted, PropType, reactive, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import Anchor from '@/components/anchor/anchor.vue'
import VirusDetection from '@/views/dashboard/_components/group-policy-settings/_components/security-protection/_components/virus-detection/virus-detection.vue'
import SystemProtection from '@/views/dashboard/_components/group-policy-settings/_components/system-protection/system-protection.vue'
import InternetProtection from '@/views/dashboard/_components/group-policy-settings/_components/security-protection/_components/internet-protection/internet-protection.vue'
import UsbGuard from '@/views/dashboard/_components/group-policy-settings/_components/security-protection/_components/usb-guard/usb-guard.vue'
import EngineSettings from '@/views/dashboard/_components/group-policy-settings/_components/security-protection/_components/engine-settings/engine-settings.vue'

import { OperateType } from '@/views/dashboard/_components/group-policy-settings/group-policy-drawer.service'
import type { AnchorItem } from '@/components/anchor/types'
import { SecurityProtectionStrategy, GroupPolicySettingsService, GroupPolicyTypes } from '@/views/dashboard/_components/group-policy-settings/group-policy-settings.service'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'


export default /*#__PURE__*/_defineComponent({
  __name: 'security-protection',
  props: {
  operateType: {
    type: String as PropType<'edit' | 'add' | 'read'>,
    default: 'edit'
  },
  policyId: {
    type: String,
    default: undefined
  },
  activeName: {
    type: String,
    default: ''
  }
},
  emits: ['cancel', 'save'],
  setup(__props, { emit: __emit }) {

const { t, locale } = useI18n()

const DEFAULT_STRATEGY: SecurityProtectionStrategy = {
  virusscan: {
    scan_all_file: 0,
    fullscan_extract: 0,
    fullscan_cdrom: 0,
    customscan_extract: 1,
    auto_fix_file: 0,
    backup_file: 1,
    strong_scan: 0,
    macro_deepScan: 0
  },
  defend: {
    spy_mode: 2,
    kernel_stable: 1,
    office_remind: 1,
    extort_protect: 0,
    auto_block_pop: 0,
    soft_install_tips: 1
  },
  security: {
    download_always_remind: 0,
    download_auto_delete: 0,
    usb: {
      protect_realtime: 1,
      protect_mode: 0,
      create_trayicon: 1,
      show_suspendedwindow: 1,
      forbid_autorun: 1,
      scan_hidepath: 1,
      scan_auto: 0
    },
    engine_kvm_open: 1,
    engine_kvm_highlevel: 0,
    engine_kvm_offline: 0,
    engine_kboost_open: 1,
    engine_kwindhunter_open: 1,
    engine_kwindhunter_level: 3
  }
}

const props = __props

const emits = __emit

const injector = useReflectiveInjector()
const service = injector.get(GroupPolicySettingsService)

const loading = ref(true)
const hasEdit = ref(false)
const activeSection = ref('#section-virus-detection')
const activeNames = ref(
  IS_JP_ONLY_BUILD
    ? ['virus-detection', 'system-protection', 'internet-protection', 'engine-settings']
    : ['virus-detection', 'system-protection', 'internet-protection', 'usb-guard', 'engine-settings']
)
const anchorRef = ref<InstanceType<typeof Anchor> | null>(null)
const contentRef = ref<HTMLElement | null>(null)

const strategy = reactive<SecurityProtectionStrategy>(JSON.parse(JSON.stringify(DEFAULT_STRATEGY)))

const anchorItems = computed<AnchorItem[]>(() => {
  void locale.value
  const items: AnchorItem[] = [
    { title: t('groupPolicySettings.secCollapseVirus'), href: '#section-virus-detection' },
    { title: t('groupPolicySettings.secCollapseSysProtect'), href: '#section-system-protection' },
    { title: t('groupPolicySettings.secCollapseInternet'), href: '#section-internet-protection' },
  ]
  if (!IS_JP_ONLY_BUILD) {
    items.push({ title: t('groupPolicySettings.secCollapseUsbGuard'), href: '#section-usb-guard' })
  }
  items.push({ title: t('groupPolicySettings.secCollapseEngine'), href: '#section-engine-settings' })
  return items
})

function getSettings() {
  loading.value = true
  service.getSettings({
    id: props.policyId,
    type: GroupPolicyTypes.SecurityProtection
  }).then(response => {
    Object.assign(strategy, response.strategy || {})
  }).finally(() => {
    loading.value = false
  })
}

function saveSettings() {
  service.saveSettings({
    id: props.policyId,
    type: GroupPolicyTypes.SecurityProtection,
    strategy: JSON.stringify(strategy)
  }).then(() => {
    service.updateEditTab(false)
    hasEdit.value = false
    emits('save', 'security-protection')
  })
}

function handleChange() {
  hasEdit.value = true
  service.updateEditTab(true)
}

function handleSave() {
  saveSettings()
}

function handleCancel() {
  emits('cancel')
}

service.hasEditTab.subscribe((val: boolean) => {
  hasEdit.value = val
})

service.saveTab.subscribe((name: string) => {
  if (name === 'security-protection') {
    saveSettings()
  }
})

watch(() => props.activeName, (newVal) => {
  if (newVal === 'security-protection') {
    getSettings()
  }
})

onMounted(() => {
  getSettings()
})

return (_ctx: any,_cache: any) => {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(ContentAdaptLayout, { class: "container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["tab-container", { readonly: __props.operateType === _unref(OperateType).read }])
      }, [
        _createVNode(Anchor, {
          ref_key: "anchorRef",
          ref: anchorRef,
          modelValue: activeSection.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeSection).value = $event)),
          items: anchorItems.value,
          offset: 10,
          container: contentRef.value,
          class: "settings-anchor"
        }, null, 8, ["modelValue", "items", "container"]),
        _createElementVNode("div", {
          ref_key: "contentRef",
          ref: contentRef,
          class: "settings-content"
        }, [
          _createVNode(_component_el_collapse, {
            modelValue: activeNames.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((activeNames).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_collapse_item, {
                name: "virus-detection",
                class: "el-card",
                id: "section-virus-detection"
              }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('groupPolicySettings.secCollapseVirus')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(VirusDetection, {
                    modelValue: strategy.virusscan,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((strategy.virusscan) = $event)),
                    readonly: __props.operateType === _unref(OperateType).read,
                    onChange: handleChange
                  }, null, 8, ["modelValue", "readonly"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_collapse_item, {
                name: "system-protection",
                class: "el-card",
                id: "section-system-protection"
              }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('groupPolicySettings.secCollapseSysProtect')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(SystemProtection, {
                    modelValue: strategy.defend,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((strategy.defend) = $event)),
                    readonly: __props.operateType === _unref(OperateType).read,
                    onChange: handleChange
                  }, null, 8, ["modelValue", "readonly"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_collapse_item, {
                name: "internet-protection",
                class: "el-card",
                id: "section-internet-protection"
              }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('groupPolicySettings.secCollapseInternet')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(InternetProtection, {
                    modelValue: strategy.security,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((strategy.security) = $event)),
                    readonly: __props.operateType === _unref(OperateType).read,
                    onChange: handleChange
                  }, null, 8, ["modelValue", "readonly"])
                ]),
                _: 1
              }),
              (!_unref(IS_JP_ONLY_BUILD))
                ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                    key: 0,
                    name: "usb-guard",
                    class: "el-card",
                    id: "section-usb-guard"
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('groupPolicySettings.secCollapseUsbGuard')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(UsbGuard, {
                        modelValue: strategy.security,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((strategy.security) = $event)),
                        readonly: __props.operateType === _unref(OperateType).read,
                        onChange: handleChange
                      }, null, 8, ["modelValue", "readonly"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_collapse_item, {
                name: "engine-settings",
                class: "el-card",
                id: "section-engine-settings"
              }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('groupPolicySettings.secCollapseEngine')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(EngineSettings, {
                    modelValue: strategy.security,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((strategy.security) = $event)),
                    readonly: __props.operateType === _unref(OperateType).read,
                    onChange: handleChange
                  }, null, 8, ["modelValue", "readonly"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ], 512)
      ], 2),
      (__props.operateType !== _unref(OperateType).read)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: handleSave,
              disabled: !hasEdit.value && __props.operateType !== _unref(OperateType).add && 0
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('common.save')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: handleCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('common.cancel')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  })), [
    [_directive_loading, loading.value]
  ])
}
}

})